import { TextAlignment, TextVerticalAlignment } from "building-types/annotation/annotationTypesEnum";
import { assertUnreachable } from "common/utils/assertUnreachable";
import type { Mat3 } from "geom/mat3";

export function mat3ToCSSMatrix(mat: Mat3): string {
  /*
  CSS matrix:
    a c e
    b d f
  Input matrix:
    0 3 6
    1 4 7
    2 5 8
  */
  const cssMatrixValues = [mat[0], mat[1], mat[3], mat[4], mat[6], mat[7]];
  return cssMatrixValues.join(" ");
}
export function textHorizontalAlignmentToTextAnchor(alignment: TextAlignment): string {
  switch (alignment) {
    case TextAlignment.CENTER:
      return "middle";
    case TextAlignment.LEFT:
      return "start";
    case TextAlignment.RIGHT:
      return "end";
    default:
      assertUnreachable(alignment);
  }
}
/**
 * This is not great since it doesn't exactly match other ways we vertically align text.
 * TODO: replace SVG elevation annotations with PlanGeometry
 */
export function textVerticalAlignmentToDominantBaseline(alignment: TextVerticalAlignment): string {
  switch (alignment) {
    case TextVerticalAlignment.CENTER:
      return "middle";
    case TextVerticalAlignment.TOP:
      return "hanging";
    case TextVerticalAlignment.BOTTOM:
      return "text-bottom";
    default:
      assertUnreachable(alignment);
  }
}
